/* ============================================
   GHOST LABEL SCENTS — Theme JS
   ============================================ */
(function () {
  'use strict';

  const $ = (s, ctx) => (ctx || document).querySelector(s);
  const $$ = (s, ctx) => [...(ctx || document).querySelectorAll(s)];

  /* ── NAV DRAWER ─────────────────────────── */
  function initNavDrawer() {
    const btn     = $('#nav-toggle');
    const drawer  = $('#nav-drawer');
    const overlay = $('#nav-overlay');
    const close   = $('#nav-close');
    if (!btn || !drawer) return;
    const open = () => { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; btn.setAttribute('aria-expanded', 'true'); };
    const shut = () => { drawer.classList.remove('open'); document.body.style.overflow = ''; btn.setAttribute('aria-expanded', 'false'); };
    btn.addEventListener('click', open);
    close?.addEventListener('click', shut);
    overlay?.addEventListener('click', shut);
    document.addEventListener('keydown', e => e.key === 'Escape' && shut());
  }

  /* ── CART DRAWER ────────────────────────── */
  function initCartDrawer() {
    const drawer  = $('#cart-drawer');
    const overlay = $('#cart-overlay');
    const close   = $('#cart-close');
    if (!drawer) return;
    window.openCart = () => { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; refreshCart(); };
    window.closeCart = () => { drawer.classList.remove('open'); document.body.style.overflow = ''; };
    $$('[data-cart-open]').forEach(el => el.addEventListener('click', window.openCart));
    close?.addEventListener('click', window.closeCart);
    overlay?.addEventListener('click', window.closeCart);
    document.addEventListener('keydown', e => e.key === 'Escape' && window.closeCart());
  }



  async function refreshCart() {
    const body = $('#cart-body');
    const totalEl = $('#cart-total-price');
    if (!body) return;
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const FREE_SHIPPING = 100;

const total = cart.total_price / 100;

const remaining = Math.max(0, FREE_SHIPPING - total);

const progress = Math.min((total / FREE_SHIPPING) * 100, 100);

const text = document.querySelector("#drawer-shipping-text");
const fill = document.querySelector("#drawer-shipping-fill");

if (fill)
    fill.style.width = progress + "%";

if (text) {

    if (remaining > 0) {

        text.innerHTML =
            `🚚 Spend <strong>$${Math.ceil(remaining)}</strong> more to unlock <strong>FREE SHIPPING</strong>`;

    } else {

        text.innerHTML =
            `🎉 Congratulations! You've unlocked <strong>FREE SHIPPING</strong>`;

    }

}
      $$('.cart-badge').forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none'; });
      if (!cart.items.length) {
        body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        if (totalEl) totalEl.textContent = '$0.00';
        return;
      }
      body.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <div class="cart-item-img"><img src="${item.image || ''}" alt="${item.title}"></div>
          <div>
            <p class="cart-item-name">${item.product_title}</p>
            ${item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
            <p class="cart-item-price">${fmtMoney(item.price)}</p>
            <a href="/cart/change?line=${item.index || 1}&quantity=0" class="cart-item-remove">Remove</a>
          </div>
        </div>`).join('');
      if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);
    } catch(e) { console.warn('Cart fetch failed', e); }
  }

  function fmtMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  /* ── ADD TO CART ────────────────────────── */
  function initATC() {
    const form = $('[data-product-form]');
    const btn  = $('[data-atc-btn]');
    if (!form || !btn) return;
    const label = btn.dataset.label || 'Add to Cart';
    form.addEventListener('submit', async e => {
      e.preventDefault();
      btn.textContent = 'Adding...';
      btn.disabled = true;
     try {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    body: new FormData(form)
  });

  if (!res.ok) {
    console.log(await res.text());
    throw new Error('add failed');
  }
  // Open side cart automatically
if (window.openCart) {
  window.openCart();
}

  btn.textContent = 'Added!';
  setTimeout(() => {
    btn.textContent = label;
    btn.disabled = false;
  }, 1800);

} catch (err) {
  console.error(err);
  btn.textContent = 'Try again';
  btn.disabled = false;

  setTimeout(() => {
    btn.textContent = label;
  }, 2000);
}
    });
  }

  /* ── SIZE BUTTONS ───────────────────────── */
  function initSizeSelect() {
    $$('.size-options').forEach(wrap => {
      $$('.size-btn', wrap).forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('unavailable')) return;
          $$('.size-btn', wrap).forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const variantId = btn.dataset.variantId;
          if (variantId) {
            const hiddenInput = $('input[name="id"]');
            if (hiddenInput) hiddenInput.value = variantId;
          }
        });
      });
    });
  }

  /* ── QTY SELECTOR ───────────────────────── */
  function initQty() {
    $$('.qty-wrap').forEach(wrap => {
      const input = $('input[name="quantity"]', wrap);
      $('[data-minus]', wrap)?.addEventListener('click', () => { if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1; });
      $('[data-plus]',  wrap)?.addEventListener('click', () => { input.value = parseInt(input.value) + 1; });
    });
  }

  /* ── GALLERY ────────────────────────────── */
  function initGallery() {
    const main   = $('#main-img');
    const thumbs = $$('.product-thumb');
    if (!main) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (src) { main.style.opacity = '0'; setTimeout(() => { main.src = src; main.style.opacity = '1'; }, 180); main.style.transition = 'opacity 0.18s ease'; }
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* ── STICKY HEADER ──────────────────────── */
  function initStickyHeader() {
    const header = $('.site-header');
    if (!header) return;
    window.addEventListener('scroll', () => { header.classList.toggle('scrolled', window.scrollY > 40); }, { passive: true });
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) { $$('.reveal').forEach(el => el.classList.add('visible')); return; }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });
    $$('.reveal').forEach(el => obs.observe(el));
  }

  /* ── HERO PARALLAX ──────────────────────── */
  function initHeroParallax() {
    const bg = $('.hero-bg');
    if (!bg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    bg.classList.add('loaded');
    let raf;
    window.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y < window.innerHeight) bg.style.transform = `translateY(${y * 0.2}px)`;
      });
    }, { passive: true });
  }

  /* ── ANNOUNCEMENT CLOSE ─────────────────── */
  function initAnnouncement() {
    const close = $('.announcement-close');
    const bar   = $('.announcement-bar');
    close?.addEventListener('click', () => bar?.remove());
  }

  /* ── FILTERS (collection) ───────────────── */
  function initFilters() {
    $$('.filter-option input').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const params = new URLSearchParams(window.location.search);
        // Simple filter: add tag param
        const tag = checkbox.value;
        const tags = params.getAll('tag');
        if (checkbox.checked) { tags.push(tag); } else { const idx = tags.indexOf(tag); if (idx > -1) tags.splice(idx, 1); }
        params.delete('tag');
        tags.forEach(t => params.append('tag', t));
        window.location.search = params.toString();
      });
    });
    const sortSelect = $('.sort-select');
    sortSelect?.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      window.location.search = params.toString();
    });
  }

  /* ── FREE SHIPPING PROGRESS ─────────────── */
  function initShippingProgress() {
    const fill = $('.shipping-progress-fill');
    if (!fill) return;
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const threshold = 5000; // $50 in cents
      const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      fill.style.width = pct + '%';
    }).catch(() => {});
  }

  /* ── WISHLIST TOGGLE ────────────────────── */
  function initWishlist() {
    $$('.btn-wishlist').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.classList.toggle('active');
        btn.innerHTML = btn.classList.contains('active') ? '♥' : '♡';
      });
    });
  }

  /* ── INIT ───────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initNavDrawer();
    initCartDrawer();
    initATC();
    initSizeSelect();
    initQty();
    initGallery();
    initStickyHeader();
    initReveal();
    initHeroParallax();
    initAnnouncement();
    initFilters();
    initShippingProgress();
    initWishlist();
    refreshCart();
  });

})();
